export default "__VITE_ASSET__pZ6JFY0a__"